<template>
  <v-container>
    <div class="tableTitle">原価集計</div>
    <table>
      <tr>
        <th>クライアント番号</th>
        <th>クライアント名</th>
        <th>時間</th>
        <th v-if="isMyHome || CanI('ReadOtherMoneyTable')">原価</th>
      </tr>
      <tr v-for="item in sortedCosts" :key="item.client_id">
        <td>{{ item.client_id }}</td>
        <td>{{ item.client_name }}</td>
        <td>{{ toFormattedTime(item.time) }}</td>
        <td v-if="isMyHome || CanI('ReadOtherMoneyTable')">
          {{ toFormattedMoney(item.salary) }}
        </td>
      </tr>
      <tr style="font-weight: bold">
        <td colspan="2" style="text-align: center">合計</td>
        <td>{{ toFormattedTime(costCounts.total) }}</td>
        <td v-if="isMyHome || CanI('ReadOtherMoneyTable')">
          {{ toFormattedMoney(yenCostCount) }}
        </td>
      </tr>
      <tr style="font-weight: bold" v-if="isMyHome || CanI('ReadOtherMoneyTable')">
        <td colspan="3" style="text-align: center">差額</td>
        <td>
          {{ toFormattedMoney(moneyCounts.subtotalSalary - yenCostCount) }}
        </td>
      </tr>
            <tr style="font-weight: bold" v-if="isMyHome || CanI('ReadOtherMoneyTable')">
        <td colspan="3" style="text-align: center">基本給・手当等小計</td>
        <td>
          {{ toFormattedMoney(moneyCounts.subtotalSalary) }}
        </td>
      </tr>
    </table>
  </v-container>
</template>
<script>
import { unixtimeToFormattedLargeTime } from "@/utils/datetime.js";
import { mapGetters } from "vuex";
export default {
  data: () => ({
    yenCostCount: {
      type: Number,
      defalut: 0,
    },
  }),
  props: {},
  computed: {
    sortedCosts() {
      const costs = [];
      const costTotal = this.costCounts.total ? this.costCounts.total : 0;
      const subtotalSalary = this.moneyCounts.subtotalSalary;
      let totalTime = 0
      if (costTotal <= 0 || subtotalSalary <= 0) return costs;
      this.yenCostCount = 0
      Object.keys(this.costCounts).forEach((key) => {
        if (key != "total") {
          const salary = Math.round(
            (subtotalSalary * this.costCounts[key].time) / costTotal
          );
          totalTime += this.costCounts[key].time
          this.yenCostCount += salary;
          costs.push({ ...this.costCounts[key], salary: salary });
        }
      });
      return costs.sort((a, b) => {
        return b.time - a.time;
      });
    },
    isMyHome() {
      return this.owner.id == this.user.uid;
    },
    ...mapGetters("timesheet", ["costCounts", "moneyCounts", "owner"]),
    ...mapGetters("auth", ["CanI", "user"]),
  },
  created() {},
  mounted() {},
  methods: {
    toFormattedTime(unixtime) {
      return unixtimeToFormattedLargeTime(unixtime);
    },
    toFormattedMoney(m) {
      const money = Number(m);
      return Number.isInteger(money)
        ? "¥ " + money.toLocaleString("ja")
        : "Invalid Money NG:" + money;
    },
  },
};
</script>
<style lang="scss" scoped>
.tableTitle {
  font-size: 16px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.tableTitle:before {
  content: "";
  background-color: #ff5722;
  display: inline-block;
  height: 15px;
  margin-right: 10px;
  position: relative;
  top: 2px;
  width: 15px;
}
table {
  margin: 10px;
  border: solid 1px;
  border-collapse: collapse;
}
th {
  text-align: left;
}
th,
td {
  border: solid 1px;
  padding: 5px 10px;
}
td {
  text-align: left;
}
.tableSubTitle {
  font-size: 14px;
  color: #616161;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
tr.subtotal {
  font-weight: bold;
  background-color: #ffccbc;
}
</style>

